import { Component, OnInit } from '@angular/core';
import {
  FormGroup,
  FormControl,
  Validators,
  AbstractControl,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../api-services/Auth/auth.service';
import { keyService } from '../api-services/keycloak/service/key.service';
/**
 * This component can access activation link id and user can be create a password.
 * If link id is valid then to show successful message and navigate to login page.
 */
@Component({
  selector: 'app-account-verification',
  templateUrl: './account-verification.component.html',
  styleUrls: ['./account-verification.component.css'],
})
export class AccountVerificationComponent implements OnInit {
  active_id: any;
  createPasswordForm = new FormGroup({
    password: new FormControl('', [
      Validators.required,
      Validators.minLength(8),
    ]),
    confirmPassword: new FormControl('', [
      Validators.required,
      Validators.minLength(8),
    ]),
  });
  postPasswordObj: any;
  mismatch: any;
  successMsg: boolean = false;
  status_message: any;
  constructor(
    private activatedRouter: ActivatedRoute,
    private router: Router,
    private activation: AuthService,
    private key_service: keyService
  ) {}

  ngOnInit(): void {
    this.active_id = this.activatedRouter.snapshot.params['activationId'];
  }
  /**
   * Submit method  can access password value and submited for password updation.
   */
  submit() {
    if (
      this.createPasswordForm.get('password').value !=
      this.createPasswordForm.get('confirmPassword').value
    ) {
      this.mismatch = true;
    } else {
      this.mismatch = false;
      this.postPasswordObj = {
        password: this.createPasswordForm.get('password').value,
        activationLink: this.active_id,
      };
      this.activation.createPasswordService(this.postPasswordObj).subscribe(
        (data) => {
          let getRes: any = data;
          if (getRes.status) {
            this.successMsg = true;
            this.status_message = getRes.message;
          } else {
            this.successMsg = true;
            this.status_message = getRes.message;
          }
        },
        (err) => {}
      );
    }
  }
}
